module.exports = __webpack_public_path__ + "AUDI-logo.png";